import { useState, useCallback } from 'react';
import { costsService } from '../services/costs.service';

export function useProductCosts() {
    const [costs, setCosts] = useState({}); // { productId: { cost, updatedAt } }
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchCosts = useCallback(async (branch, force = false) => {
        if (!branch) return;

        setLoading(true);
        setError(null);
        try {
            const data = await costsService.getCosts(branch, force);
            setCosts(data || {});
        } catch (err) {
            console.error(err);
            setError('Error al cargar costos');
        } finally {
            setLoading(false);
        }
    }, []);

    const updateProductCost = useCallback(async (branch, productId, cost) => {
        try {
            await costsService.updateCost(branch, productId, cost);
            // Optimistic update (already handled by service cache, but we update state too)
            setCosts(prev => ({
                ...prev,
                [productId]: { cost: Number(cost), updatedAt: Date.now() }
            }));
            return true;
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return {
        costs,
        loading,
        error,
        fetchCosts,
        updateProductCost
    };
}
